import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import store from 'store/Store';
import Actions from 'Actions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import BuyNowPayLaterEN from 'components/GlobalModals/BuyNowPayLaterModal/locales/BuyNowPayLater_en_US';
import BuyNowPayLaterFR from 'components/GlobalModals/BuyNowPayLaterModal/locales/BuyNowPayLater_fr_CA';
import BuyNowPayLater from 'components/GlobalModals/BuyNowPayLaterModal/BuyNowPayLater';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;

class BuyNowPayLaterModal extends BaseClass {
    getText = (text, vars) => getLocalisedDataFromResource(BuyNowPayLaterEN, BuyNowPayLaterFR)(text, vars);

    requestClose = () => {
        const { callback } = this.props;

        if (callback && typeof callback === 'function') {
            callback();
        }

        store.dispatch(Actions.showBuyNowPayLaterModal({ isOpen: false }));
    };

    render() {
        return (
            <BuyNowPayLater
                getText={this.getText}
                requestClose={this.requestClose}
                {...this.props}
            />
        );
    }
}

export default wrapComponent(BuyNowPayLaterModal, 'BuyNowPayLaterModal');
